var map = {
	"./1/Waqar_Spotin_news.jpg": 233,
	"./1/article": 7,
	"./1/article.json": 7,
	"./10/North_star_web_news.png": 234,
	"./10/article": 8,
	"./10/article.json": 8,
	"./11/article": 9,
	"./11/article.json": 9,
	"./11/oskar_lindholm_ceo.jpg": 235,
	"./11/vinsider_sporthalsa.png": 236,
	"./12/Andreas_Boman_Mathem.jpeg": 237,
	"./12/article": 10,
	"./12/article.json": 10,
	"./12/tasteline.png": 238,
	"./13/Spotin_x_Books.jpg": 239,
	"./13/article": 11,
	"./13/article.json": 11,
	"./14/article": 12,
	"./14/article.json": 12,
	"./14/selma_stories.jpg": 240,
	"./15/Bonnierforlagen_case_study.png": 241,
	"./15/article": 13,
	"./15/article.json": 13,
	"./16/Portal_release.png": 242,
	"./16/article": 14,
	"./16/article.json": 14,
	"./2/article": 15,
	"./2/article.json": 15,
	"./2/kristoffer_karlsson_news.jpg": 243,
	"./3/Bonnierforlagen_X_Spotin_news.jpg": 244,
	"./3/article": 16,
	"./3/article.json": 16,
	"./4/article": 17,
	"./4/article.json": 17,
	"./4/spotinxFIPP.jpg": 245,
	"./5/SpotinxArctic15.png": 246,
	"./5/article": 18,
	"./5/article.json": 18,
	"./6/article": 19,
	"./6/article.json": 19,
	"./6/futr_london.png": 247,
	"./7/article": 20,
	"./7/article.json": 20,
	"./7/norstat_survey.jpg": 248,
	"./8/DMEXCO_web_news.png": 249,
	"./8/article": 21,
	"./8/article.json": 21,
	"./9/article": 22,
	"./9/article.json": 22,
	"./9/bits_pretzels_news_image.png": 250
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 401;


//////////////////
// WEBPACK FOOTER
// ./pages/news ^\.\/.*$
// module id = 401
// module chunks = 0